module.exports = __webpack_public_path__ + "img/playwork oval 20.421efcce.svg";